import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { FC, PropsWithChildren } from 'react'
import { Colors } from '~/assets/style/colors'
import { WithClassName } from '~/types/utils'

type TableCellProps = WithClassName & {
  colspan?: number
}

/**
 * 4px of vertical padding rather than 8. The row carries the height now — a 48px floor, as `height`, which
 * is what CSS treats as a minimum on a table row — so the padding no longer has to add up to it, and a
 * single line of text is centred in the row rather than pressed against its top.
 *
 * It still matters for the cells that outgrow the floor: one holding an input, a chip or wrapped text grows
 * past 48px, and 4px is the breathing room it gets there.
 */
const Td = styled.td`
  padding: 4px 12px;
  position: relative;
  border-bottom: 1px solid ${Colors.Platinum};

  &:last-of-type {
    box-shadow: inset -1px 0 0 0 ${Colors.Platinum};
  }
  &:first-of-type {
    border-radius: 0;
    border-bottom: 1px solid ${Colors.Platinum};
    box-shadow: inset 1px 0 0 0 ${Colors.Platinum};
  }

  &:last-of-type:first-of-type {
    box-shadow:
      inset -1px 0 0 0 ${Colors.Platinum},
      inset 1px 0 0 0 ${Colors.Platinum};
  }
`

export const BaseTableCell: FC<PropsWithChildren<TableCellProps>> = ({ children, colspan = 1, className }) => (
  <Td colSpan={colspan} className={className}>
    {children}
  </Td>
)

const TableCell = styled(BaseTableCell)``

export const HideBorderCell = styled(TableCell)<{ hideBorder: boolean }>`
  ${({ hideBorder }) =>
    hideBorder &&
    css`
      border-bottom: transparent;

      :first-of-type {
        border-bottom: transparent;
      }
    `}
`

export default TableCell
